import React, { useState, useEffect } from "react";
import { Typography, Paper } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import CloseIcon from "@material-ui/icons/Close";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import AlertDialog from "../../biztran_controls/AlertDialog";
import CreateOpportunity from "./CreateOpportunity";
import UseFetchData from "../../../hooks/UseFetchData";
import { useHistory } from 'react-router-dom';


const OpportunityViewHeader = ({ OpportunityID, OpportunityMainData, PopulateData, ProductCount }) => {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [OPID, SetOPID] = useState("");
  const [PredictedClosingDate, setPredictedClosingDate] = useState("");
  const [CreatedBy, setCreatedBy] = useState("");
  const [GeneratedBy, setGeneratedBy] = useState("");
  const [RevNo, setRevNo] = useState(0);
  const [HandledBy, setHandledBy] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [Company, setCompany] = useState("");
  const [TotalAmount, setTotalAmount] = useState("");
  const [OpportunityNo, setOpportunityNo] = useState("");
  const [OpportunityDate, setOpportunityDate] = useState("");
  const [Lead, setLead] = useState("");
  const [Contact, setContact] = useState("");
  const [LeadSource, setLeadSource] = useState("");
  const [OpportunityType, setOpportunityType] = useState("");
  const [OpportunityStage, setOpportunityStage] = useState("");
  const [BillAddress, setBillAddress] = useState("");
  const [BillCountry, setBillCountry] = useState("");
  const [BillState, setBillState] = useState("");
  const [BillCity, setBillCity] = useState("");
  const [BillPINCode, setBillPINCode] = useState("");
  const [ShipAddress, setShipAddress] = useState("");
  const [ShipCity, setShipCity] = useState("");
  const [ShipPINCode, setShipPINCode] = useState("");
  const [ShipCountry, setShipCountry] = useState("");
  const [ShipState, setShipState] = useState("");
  const [LeadID, setLeadID] = useState("");
  const [isOpenConvert, setOpenConvert] = useState(false);
  const [DisableConvetbtn, setDisableConvetbtn] = useState(false);
  const [Response, fetchData] = UseFetchData();
  const history = useHistory();


  const handleOpenModal = () => {
    setOpen(true);
    SetOPID(OpportunityID);
  };
  const convertOpenModal = () => {
    setOpenConvert(true);
    /* const confirmBox = window.confirm(
      "Do you really want to delete this Crumb?"
    )
    if (confirmBox === true) {
      setOpenConvert(true);
    } */
  }
  const OpenModal = () => {
    setOpen(true);
    SetOPID("");
  };

  const ConvertToQuotation = () => {
    // debugger;
    if (ProductCount > 0) {
      var bodyFormData = new FormData();
      bodyFormData.append("OpportunityID", OpportunityID);
      fetchData("Opportunity/ConvertToQuotation", bodyFormData);
      setOpenConvert(false);
      setDisableConvetbtn(true);
    }
    else {
      setOpenConvert(false);
      alert('Add Some Products.')
    }
  }

  useEffect(() => {
    if (OpportunityMainData !== undefined && OpportunityMainData.length > 0) {
      // debugger;
      setPredictedClosingDate(OpportunityMainData[0].PredictedClosingDate === null ? "" : OpportunityMainData[0].PredictedClosingDate);
      setCreatedBy(OpportunityMainData[0].CreatedBy === null ? "" : OpportunityMainData[0].CreatedBy);
      setAccountName(OpportunityMainData[0].AccountName);
      setRevNo(OpportunityMainData[0].RevNo);
      setTotalAmount(OpportunityMainData[0].TotalAmount);
      setCompany(OpportunityMainData[0].CompanyCode);
      setHandledBy(OpportunityMainData[0].HandledBy === null ? "" : OpportunityMainData[0].HandledBy);
      setGeneratedBy(OpportunityMainData[0].GeneratedBy === null ? "" : OpportunityMainData[0].GeneratedBy);
      setLeadID(OpportunityMainData[0].LeadID === null ? "" : OpportunityMainData[0].LeadID);
      setOpportunityNo(OpportunityMainData[0].OpportunityNo);
      setOpportunityDate(OpportunityMainData[0].OpportunityDate === null ? "" : OpportunityMainData[0].OpportunityDate);
      setLead(OpportunityMainData[0].LeadNo === null ? "" : OpportunityMainData[0].LeadNo);
      setContact(OpportunityMainData[0].ContactName);
      setLeadSource(OpportunityMainData[0].LeadSource);
      setOpportunityType(OpportunityMainData[0].OpportunityType);
      setOpportunityStage(OpportunityMainData[0].OpportunityStage);
      if (OpportunityMainData[0].OpportunityStage === "Quotation") {
        setDisableConvetbtn(true);
      }
      // debugger;
      setBillAddress(OpportunityMainData[0].BillAddress1 + " " + OpportunityMainData[0].BillAddress2);
      setBillCity(OpportunityMainData[0].BillCity === null ? "" : OpportunityMainData[0].BillCity);
      setBillState(OpportunityMainData[0].BillState === null ? "" : OpportunityMainData[0].BillState);
      setBillCountry(OpportunityMainData[0].BillCountry === null ? "" : OpportunityMainData[0].BillCountry);
      setBillPINCode(OpportunityMainData[0].BillPINCode === null ? "" : OpportunityMainData[0].BillPINCode);
      setShipAddress(OpportunityMainData[0].ShipAddress1 === null ? "" : OpportunityMainData[0].ShipAddress1 + " " + OpportunityMainData[0].ShipAddress2 === null ? "" : OpportunityMainData[0].ShipAddress2);
      setShipCity(OpportunityMainData[0].ShipCity === null ? "" : OpportunityMainData[0].ShipCity);
      setShipState(OpportunityMainData[0].ShipState === null ? "" : OpportunityMainData[0].ShipState);
      setShipCountry(OpportunityMainData[0].ShipCountry === null ? "" : OpportunityMainData[0].ShipCountry);
      setShipPINCode(OpportunityMainData[0].ShipPINCode === null ? "" : OpportunityMainData[0].ShipPINCode);
    }
  }, [OpportunityMainData]);

  useEffect(() => {
    if (Response.Response === true) {
      alert('Quotation Converted Successfully.');
      var QuotationID = Response.ID;
      history.push('/quotation/QuotationView', { QuotationID });
    }
    else if (Response.Response === false) {
      alert('Error in Convert Quotation.');
    }
  }, [Response])

  return (
    <Paper elevation={3}>
      <Typography className={classes.headertext} noWrap>
        <AccountBoxIcon style={{ fontSize: 36 }} />
        Opportunity
        <div style={{ width: "80%" }}>
          <div style={{ float: "right", marginTop: -3 }}>
            {/* <BiztranControls.Button
              text="Add New"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => {
                OpenModal();
              }}
            /> */}
            <BiztranControls.Button
              text="EDIT"
              startIcon={<EditIcon />}
              onClick={() => {
                handleOpenModal();
              }} />
            <BiztranControls.Button
              text="Convert to Qtn"
              disabled={DisableConvetbtn}
              onClick={() => {
                convertOpenModal();
              }} />
          </div>
        </div>
      </Typography>
      <Grid spacing={1} container style={{ marginTop: 7, marginLeft: 10 }}>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Opportunity No:</h5>
            <h5 style={{ color: "#0096FF" }}>{OpportunityNo + " - " + OpportunityDate}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Company:</h5>
            <h5 style={{ color: "#0096FF" }}>{Company}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 140 }}>Lead:</h5>
            <h5 style={{ color: "#0096FF" }}>{Lead}</h5>
          </Grid>

          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Status:</h5>
            <h5 style={{ color: "green" }}>{OpportunityStage}</h5>
          </Grid>
        </Grid>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Account Name:</h5>
            <h5 style={{ color: "#0096FF" }}>{AccountName}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Contact:</h5>
            <h5 style={{ color: "#0096FF" }}>{Contact}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 140 }}>Lead Source:</h5>
            <h5 style={{ color: "#0096FF" }}>{LeadSource}</h5>
          </Grid>
        </Grid>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Generated By:</h5>
            <h5 style={{ color: "#0096FF" }}>{GeneratedBy}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Handled By:</h5>
            <h5 style={{ color: "#0096FF" }}>{HandledBy}</h5>
          </Grid>

          <Grid item xs={4} container direction="row">
            <h5 style={{ width: 140 }}>Predicted Closing Date:</h5>
            <h5 style={{ color: "#0096FF" }}>{PredictedClosingDate}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
          </Grid>
        </Grid>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Billing Address:</h5>
            <h5 style={{ color: "#0096FF" }}>{BillAddress + " " + BillCity}</h5>
            <Grid item md={3} container direction="row">
              <h5 style={{ width: 110, color: "#0096FF" }}>{BillState + " " + BillCountry + " " + BillPINCode}</h5></Grid>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Shipping Address:</h5>
            <h5 style={{ color: "#0096FF" }}>{ShipAddress + " " + ShipCity}</h5>
            <Grid item md={3} container direction="row">
              <h5 style={{ width: 110, color: "#0096FF" }}> {ShipState + " " + ShipCountry + " " + ShipPINCode}</h5></Grid>
          </Grid>
        </Grid>
      </Grid>
      <ModalFrame
        title="Opportunity Details"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CreateOpportunity
          OpportunityID={OPID}
          setOpen={setOpen}
          PopulateData={PopulateData}
          disabled={true}
          LeadID={LeadID}
        />
      </ModalFrame>
      <AlertDialog
        message="Do you want to convert to quotation?"
        isOpen={isOpenConvert}
        setOpenConvert={setOpenConvert}
      >
        <Grid spacing={2} container direction="row">
          <Grid item xs={12}>
            <div style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                <BiztranControls.Button
                  text="Convert"
                  startIcon={<SwapHorizIcon />}
                  onClick={ConvertToQuotation}
                />
                <BiztranControls.Button
                  text="Cancel"
                  onClick={() => { setOpenConvert(false); }}
                  startIcon={<CloseIcon />}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </AlertDialog>
    </Paper>
  );
};

const useStyles = makeStyles((theme) => ({
  header: {
    width: "100%",
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.2rem",
    display: "flex",
    flexDirection: "row",
  },
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.3rem",
    display: "flex",
    flexDirection: "row",
  },
  headerCmn: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    fontSize: "1rem",
    display: "flex",
    flexDirection: "row",
    margin: "0.3rem",
    fontWeight: "bold",
  },
}));

export default OpportunityViewHeader;
